// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"68":"8a148452","160":"2aaa6436","186":"984ba684","403":"f0253a33","417":"25493c3b","465":"7353f9dd","786":"0825e174","920":"3dc7401f","963":"b93f9a58"}[chunkId] + ".chunk.css";
};